import { LoadingButton } from '@mui/lab';
import { AppBar, Toolbar, Typography, Button, Stack, TextField, Divider, CircularProgress, Card, Box } from '@mui/material'
import { addDoc, collection, doc } from 'firebase/firestore';
import { getDownloadURL, getStorage, ref, uploadBytesResumable } from 'firebase/storage';
import React, { useState } from 'react'
import Dropzone from 'react-dropzone';
import { auth, db } from '../../../firebase';

function UploadPricing({id}) {

    
    const storage = getStorage()
    const [post, setpost] = useState("")
    const [images, setImages] = useState([]);
    const [loading, setloading] = useState(false)
    const [uploadProgress, setUploadProgress] = useState(0);

    
      const handleUpload = () => {
        if (post.trim() === "") {
          alert("Write something to continue");
          return;
        }
        if (images.length > 0) {
          uploadImage(images[0]);
        }  
      }; 
   
        const uploadImage = async (image) => {  
          setloading(true)
          if(image){
            const _id = Date.now();
  
            const fileRef = ref(storage, `businessFiles/${image.name}_${_id}`);
            const uploadTask = uploadBytesResumable(fileRef, image);
          // Listen to state_changed event to track progress
          uploadTask.on('state_changed',
            (snapshot) => {
              const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              console.log(progress)
              setUploadProgress(progress);
            },
            (error) => {
              console.error(`Error uploading ${image.name}: ${error.message}`); 
            },
            () => {
              // Upload completed successfully
              getDownloadURL(fileRef).then(async (downloadURL) => {
                await addDoc(collection(db, "business", id, "files"), {
                  post,
                  createdAt : Date.now(),
                  file : downloadURL,                
                });
      });
      setpost("")
      setImages([])
      setUploadProgress(0)
      setloading(false)
            }
          ); }
      }  
     



  return (
    <div>
        <Stack mb={5}>
          <Typography variant="h6" gutterBottom>
            Upload pricing guide
          </Typography>      
           
          <Card sx={{p:3}}>
    <Box>    
        <Stack      >
        
        <TextField
        fullWidth  
         type="post"
        label="File Title"
        value={post}
        onChange={(event) => setpost(event.target.value)}
      />

  {uploadProgress > 0 && <CircularProgress fullWidth
      variant="determinate"
      value={uploadProgress}
      sx={{ my: 2 }}
    />}
    <Stack direction={"row"} sx={{mt:2}} justifyContent={"space-between"}>
    <Dropzone onDrop={files => setImages(files)}>
                {({getRootProps, getInputProps}) => (
                  <div className="container">
                    <div
                      {...getRootProps({
                        className: 'dropzone',
                        onDrop: event => event.stopPropagation()
                      })}
                    >
                      <input {...getInputProps()} />
                      <p>Click to select files</p>
                      {images.length === 1 && images[0].name}
                    </div>
                    </div>
                )}
              </Dropzone>
  
    </Stack><br/>
        </Stack>
        </Box>
      <LoadingButton loading={loading}   variant="contained" onClick={()=>handleUpload()} color="success">Upload</LoadingButton>
    </Card>
        </Stack>
    </div>
  )
}

export default UploadPricing